export default __webpack_public_path__ + "static/media/coupon-accept.47dded5f.jpeg";